export { default } from './weekInjected';



// WEBPACK FOOTER //
// ../utilities/Week/index.js